var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dg-title",class:{ 'line': _vm.line }},[_c('span',{staticClass:"t-[16] font-600 t-[#303133] txt"},[_vm._t("default")],2),_vm._t("tip")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }